// extracted by mini-css-extract-plugin
var _1 = "Footer-module_footer__vYhDtV";
export { _1 as "footer" }
